module.exports = __webpack_public_path__ + "img/aios.5169b377.png";